import { Outlet } from 'react-router-dom'

import CollectionsBootstrap from 'modules/external_users/lib/SettingsCollectionsBootstrap'

const Container = () => {
  return <Outlet />
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
